import React from "react";
import { useTranslation } from "react-i18next";
import BaseIcon from "../../../components/BaseIcon";

export default function DescriptionFeedbackModal() {
  const { t } = useTranslation();
  return (
    <div className='feedback-modal__desc'>
      <div className='feedback-modal__form__desc-icon'><BaseIcon name={'hand_like'} /> {t("compromise_feedback.feedback_description.desc1")}</div>
      <p>{t("compromise_feedback.feedback_description.desc2")}</p>
    </div>
  );
}
